<template>
  <div class="directory-more">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <div class="content page-content">
      <div class="page-title-red">名录</div>
      <dashed-list :list="directories" link="/article/articleDetail?type=directory&id=" type="img" />
      <div class="pagination">
        共{{ total }}条
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          background
          :pager-count="5"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import DashedList from "@/components/DashedList.vue"
import { getNewsList } from "@/api/news.js";
export default {
  data() {
    return {
      directories: [],
      pageNum: 1,
      total: 0,
      pageSize: 10,
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,DashedList
  },
  methods: {
    getList(){
      getNewsList({
        categorys: '名录',
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
      }).then(res=>{
        const data = res.data;
        this.directories = data.list;
        this.total = data.total;
      });
      // const res = {
      //   "errCode": 0,
      //   "errMessage": "查询成功！",
      //   "data": {
      //     "pageNum": 1,
      //     "pageSize": 13,
      //     "size": 13,
      //     "startRow": 0,
      //     "endRow": 12,
      //     "total": 13,
      //     "pages": 1,
      //     "list": [
      //     { id: 1, title: '审定合格面层产品名录审定合格面层产品名录审定合格面层产品名录审定合格面层产品名录', img: require('@/assets/image/service/sm3.png')},
      //     { id: 12, title: '审定合格面层产品名录2', img: require('@/assets/image/service/sm3.png')},
      //     { id: 13, title: '审定合格面层产品名录3', img: require('@/assets/image/service/sm3.png')},
      //     { id: 14, title: '审定合格面层产品名录4', img: require('@/assets/image/service/sm3.png')},
      //     { id: 15, title: '审定合格面层产品名录5', img: require('@/assets/image/service/sm3.png')},]
      //   }
      // };
    },
    handleCurrentChange(v) {
      this.pageNum = v;
      this.getList();
    },
    handleSizeChange(v){
      this.pageSize = v;
      this.getList();
    }
  },
  mounted(){ 
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>